<div class="frequency">
  <div class="custom-field">
    <div class="label">{{ "audience.frequency" | translate }}</div>
    <div class="operator-box new-style-custom-input" [matMenuTriggerFor]="frequencyOperatorsDropdown">
      <span class="operator-text">{{ "audience.frequencyOperators." + frequencyOperator | translate }}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
  </div>
  <mat-menu #frequencyOperatorsDropdown="matMenu" class="frequency-dropdown-menu">
    <div>
      @for (frequencyOperator of FrequencyOperators; track frequencyOperator) {
        <div>
          <button mat-menu-item (click)="filterFrequencyOperatorUpdated(frequencyOperator)">
            <span>{{ "audience.frequencyOperators." + frequencyOperator | translate }}</span>
          </button>
        </div>
      }
    </div>
  </mat-menu>
  <mat-form-field class="new-style-input number-input-field" appearance="outline" required>
    <input
      matInput
      type="number"
      [class.invalid]="frequencyValueError"
      [formControl]="frequencyValue"
      [min]="1"
      required
      (ngModelChange)="filterFrequencyOperatorUpdated(frequencyOperator)" />
  </mat-form-field>
  @if (frequencyValueError) {
    <div class="frequency-validation-row">{{ frequencyValueError | translate }}</div>
  }
  <span class="title-field">{{ "generic.times" | translate | lowercase }}</span>
</div>
